import { normalizeApiOrigin } from './apiOrigin';

/**
 * Resolve referência de mídia armazenada (S3 via API, URL absoluta ou data URL).
 * Valores com prefixo "s3:" vêm de POST /api/admin/media/upload.
 * Chaves `media/...` sem prefixo também são aceitas (mesmo GET /api/media?key=).
 */
export function resolveMediaUrl(stored: string, apiBase: string): string {
  if (!stored) return '';
  const t = stored.trim();
  if (t.startsWith('s3:')) {
    const key = t.slice(3).replace(/^\/+/, '');
    const base = apiBase ? normalizeApiOrigin(apiBase) : '';
    const path = `/api/media?key=${encodeURIComponent(key)}`;
    return base ? `${base}${path}` : path;
  }
  if (t.startsWith('media/') && !t.includes('://')) {
    const base = apiBase ? normalizeApiOrigin(apiBase) : '';
    const path = `/api/media?key=${encodeURIComponent(t)}`;
    return base ? `${base}${path}` : path;
  }
  return stored;
}
